<organization-top-navbar></organization-top-navbar>
<div class="container">
  <div class="row mt-5 text-center">
    <div>
      <img class="img-fluid" src="../../../assets/img/nasar_logo.png" alt="Nasar Logo" class="height-132"
        class="width-15rem">
    </div>
  </div>
</div>

<section class="img-container text-center img-fluid my-3">
  <div class="centered mt-4 mb-3">
    <h1>{{ 'BOOKING_PARTNERS.NAZAR_PARTNER' | transloco }}</h1>
    <p class="lead">{{ 'BOOKING_PARTNERS.NAZAR_PARTNER_DESC' | transloco }}</p>
  </div>
</section>

<div class="section">
  <div class="row mb-4 text-center">
    <div>
      <img class="img-fluid mx-auto" src="../../../assets/img/thumbnail_Flygets-logo.png" alt="Flygets Logo"
        class="width-13rem">
    </div>
  </div>
</div>

<app-itinerary [organizationId]="'3868ef69-054c-40bd-93ae-85cf08e4c71f'"></app-itinerary>
<mat-divider class="my-5"></mat-divider>

<section class="container">
  <h2>{{ 'FLYGETS.CENTRAL.TITLE' | transloco }}</h2>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY2' | transloco }}</p>
  <p class="lead">{{ 'FLYGETS.CENTRAL.BODY3' | transloco }} <a [routerLink]="['/flygets/hitta-hit']">{{
      'FLYGETS.CENTRAL.BODY4' | transloco }}</a></p>
  <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
  <div class="container-fluid">
    <h2>{{ 'FLYGETS.PRICEEXAMPLE.TITLE' | transloco }}</h2>
    <div class="row">

      <div class="col-md mb-4">
        <div class="card shadow clickable" routerLink="/parkifly/nazar">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.1WEEK' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">621 <small class="text-muted">SEK</small></h1>
            <p class="text-muted text-center">Ordinarie pris 690 <small class="text-muted">SEK</small></p>
          </div>
        </div>
      </div>

      <div class="col-md mb-4">
        <div class="card shadow clickable" routerLink="/parkifly/nazar">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.2WEEK' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">873 <small class="text-muted">SEK</small></h1>
            <p class="text-muted text-center">Ordinarie pris 970 <small class="text-muted">SEK</small></p>
          </div>
        </div>
      </div>

      <div class="col-md mb-4">
        <div class="card shadow clickable" routerLink="/parkifly/nazar">
          <div class="card-header">
            <h4 class="my-0 font-weight-normal text-center">{{ 'FLYGETS.PRICEEXAMPLE.3WEEK' | transloco }}</h4>
          </div>
          <div class="card-body">
            <h1 class="card-title pricing-card-title text-center">1134 <small class="text-muted">SEK</small></h1>
            <p class="text-muted text-center">Ordinarie pris 1260 <small class="text-muted">SEK</small></p>
          </div>
        </div>
      </div>

    </div>
  </div>
  <mat-divider class="my-5"></mat-divider>
</section>

<section #target>
  <div class="container">
    <h2>{{ 'FLYGETS.BOOKING.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY1' | transloco }}</p>
    <h2>{{ 'FLYGETS.BOOKING.TITLE2' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY2' | transloco }}</p>
    <p class="lead"><strong>{{ 'FLYGETS.BOOKING.TITLE3' | transloco }}</strong></p>
    <h2>{{ 'FLYGETS.BOOKING.TITLE4' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.BOOKING.BODY3' | transloco }}</p>
    <p class="lead"><a [routerLink]="['/flygets/faq']">{{ 'FLYGETS.BOOKING.BODY4' | transloco }}</a></p>
  </div>

  <mat-divider class="my-5"></mat-divider>
</section>

<section class="container">
  <section>
    <h2>{{ 'FLYGETS.TRANSFER.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY1' | transloco }}</p>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY2' | transloco }}</p>
    <p class="lead">{{ 'FLYGETS.TRANSFER.BODY3' | transloco }}</p>
  </section>

  <mat-divider class="my-5"></mat-divider>
  <section>
    <h2>{{ 'FLYGETS.SOCIAL.TITLE' | transloco }}</h2>
    <p class="lead">{{ 'FLYGETS.SOCIAL.BODY' | transloco }} <a href="https://www.matchedin.se"
        target="_blank">www.matchedin.se</a></p>
  </section>
</section>

<section class="container">
  <div class="row text-center">
    <div class="col-lg-4 clickable" (click)="scrollToElement(target)">
      <img src="../../../assets/img/boka1.png" alt="booking-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.BOOKING.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.BOOKING.TEXT' | transloco }}</p>
    </div>

    <div class="col-lg-4 clickable" [routerLink]="['/flygets/kontakta-oss']">
      <img src="../../../assets/img/tjanster1.png" alt="contact-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.CONTACT.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.CONTACT.TEXT' | transloco }}</p>
    </div>

    <div class="col-lg-4 clickable" [routerLink]="['/flygets/hitta-hit']">
      <img src="../../../assets/img/hitta_hit1.png" alt="pricing-image">
      <h2 class="my-4">{{ 'FLYGETS.ACTIONS.FINDUS.TITLE' | transloco }}</h2>
      <p class="lead">{{ 'FLYGETS.ACTIONS.FINDUS.TEXT' | transloco }}</p>
    </div>
  </div>
</section>

<div class="jumbotron jumbotron-fluid mt-4">
  <div class="container">
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT1' | transloco }}</p>
    <a [routerLink]="['/flygets/kontakta-oss']">{{ 'FLYGETS.CONTACT.FORM' | transloco }}</a><br>
    <a href="mailto: info@flygets.se">info&#64;flygets.se</a><br>
    <a href="tel: 010-330 03 33"> 010-330 03 33</a>
    <p class="lead">{{ 'FLYGETS.CONTACT.TEXT3' | transloco }}</p>
  </div>
</div>

<app-small-footer></app-small-footer>